import {
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import GrpPercentageSettingsTable from './GrpPercentageSettingsTable/GrpPercentageSettingsTable';
import usePlanStore from '../../../../../../../../../store/planStore';

export interface GrpPercentageSettingsAccordionProps {
  isExpanded: boolean;
}

export default function GrpPercentageSettingsAccordion({
  isExpanded = false,
}: GrpPercentageSettingsAccordionProps) {
  const { countryForms, selectedCountry } = usePlanStore();
  const grpTable = countryForms[selectedCountry!]?.offline?.tv?.grpTable ?? [];
  return (
    <Accordion
      sx={{
        '.MuiAccordionSummary-root': {
          borderTop: 'unset',
          borderBottom: 'unset',
          paddingLeft: '15px',
          borderRadius: '5px',
        },
      }}
      expanded={isExpanded}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          display: 'flex',
          flexDirection: 'row-reverse',
          alignItems: 'center',
          height: '24px',
          background: 'white',
          '.MuiAccordionSummary-content': {
            height: 'unset',
            pl: 0,
          },
        }}
      >
        <Typography variant="body2" fontWeight={700} pl={1}>
          GRP % SETTINGS
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ background: '#fff', padding: 0 }}>
        {grpTable && <GrpPercentageSettingsTable />}
      </AccordionDetails>
    </Accordion>
  );
}
